import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  status: 'idle',
  phase: null,
  sessionId: null,
  conversationId: null,
  isSpeaking: false,
  isAISpeaking: false,
  isMuted: false,
  isSpeakerOn: true,
  isMicOn: true,
  duration: 0,
  transcript: [],
  greeting: '',
  companyName: '',
  companySlug: '',
  settings: null,
  error: null,
  demoMode: false,
  micAvailable: false,
  userText: '',
  sendCount: 0,
};

const callSlice = createSlice({
  name: 'call',
  initialState,
  reducers: {
    initiateCall: (state) => {
      state.status = 'calling';
      state.phase = 'ringing';
      state.duration = 0;
      state.transcript = [];
      state.error = null;
      state.demoMode = false;
      state.micAvailable = false;
    },
    setPhase: (state, action) => {
      state.phase = action.payload;
    },
    setConnecting: (state) => {
      state.phase = 'connecting';
      state.status = 'connecting';
    },
    setConnected: (state) => {
      state.status = 'connected';
      state.phase = 'connected';
    },
    setSessionInfo: (state, action) => {
      state.sessionId = action.payload.sessionId;
      state.conversationId = action.payload.conversationId;
      state.greeting = action.payload.greeting;
      state.settings = action.payload.settings;
    },
    setCompanyInfo: (state, action) => {
      state.companyName = action.payload.name;
      state.companySlug = action.payload.slug;
    },
    addTranscript: (state, action) => {
      state.transcript.push(action.payload);
    },
    setUserSpeaking: (state, action) => {
      state.isSpeaking = action.payload;
      state.isAISpeaking = false;
    },
    setAISpeaking: (state, action) => {
      state.isAISpeaking = action.payload;
      if (action.payload) state.isSpeaking = false;
    },
    toggleMute: (state) => {
      state.isMuted = !state.isMuted;
    },
    toggleSpeaker: (state) => {
      state.isSpeakerOn = !state.isSpeakerOn;
    },
    toggleMic: (state) => {
      state.isMicOn = !state.isMicOn;
    },
    incrementDuration: (state) => {
      state.duration += 1;
    },
    endCall: (state) => {
      return { ...initialState };
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.status = 'error';
    },
    clearError: (state) => {
      state.error = null;
    },
    setDemoMode: (state, action) => {
      state.demoMode = action.payload;
    },
    setMicAvailable: (state, action) => {
      state.micAvailable = action.payload;
    },
    setUserText: (state, action) => {
      state.userText = action.payload;
    },
  },
});

export const {
  initiateCall,
  setPhase,
  setConnecting,
  setConnected,
  setSessionInfo,
  setCompanyInfo,
  addTranscript,
  setUserSpeaking,
  setAISpeaking,
  toggleMute,
  toggleSpeaker,
  toggleMic,
  incrementDuration,
  endCall,
  setError,
  clearError,
  setDemoMode,
  setMicAvailable,
  setUserText,
} = callSlice.actions;

export const selectCallStatus = (state) => state.call.status;
export const selectCallPhase = (state) => state.call.phase;
export const selectTranscript = (state) => state.call.transcript;
export const selectDuration = (state) => state.call.duration;
export const selectIsMuted = (state) => state.call.isMuted;
export const selectIsSpeakerOn = (state) => state.call.isSpeakerOn;
export const selectIsMicOn = (state) => state.call.isMicOn;
export const selectIsSpeaking = (state) => state.call.isSpeaking;
export const selectIsAISpeaking = (state) => state.call.isAISpeaking;
export const selectSessionId = (state) => state.call.sessionId;
export const selectSettings = (state) => state.call.settings;
export const selectDemoMode = (state) => state.call.demoMode;
export const selectMicAvailable = (state) => state.call.micAvailable;
export const selectUserText = (state) => state.call.userText;
export const selectError = (state) => state.call.error;

export default callSlice.reducer;
